import { render, staticRenderFns } from "./ToolboxWidget.vue?vue&type=template&id=3a590171&scoped=true"
import script from "./ToolboxWidget.vue?vue&type=script&lang=js"
export * from "./ToolboxWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a590171",
  null
  
)

export default component.exports